import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "dataset-header"
};
const _hoisted_2 = { class: "d-flex flex-wrap ga-2" };
import { computed } from "vue";
import { filesize as filesizeLib } from "filesize";
import { useStore } from "@/store";
import { formatDate } from "@/utils/dateUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DatasetHeader',
    setup(__props) {
        const store = useStore();
        // Computed properties
        const dataset = computed(() => {
            return store.current_dataset;
        });
        const numItems = computed(() => {
            return store.current_dataset_manifest && store.current_dataset_manifest.items
                ? Object.values(store.current_dataset_manifest.items).length
                : 0;
        });
        const total_size_in_bytes = computed(() => {
            if (!store.current_dataset_manifest ||
                !store.current_dataset_manifest.items) {
                return 0;
            }
            let total = 0;
            Object.values(store.current_dataset_manifest.items).forEach((item) => {
                total = total + item.size_in_bytes;
            });
            return total;
        });
        // Helper functions
        function filesize(bytes) {
            return filesizeLib(bytes);
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_avatar = _resolveComponent("v-avatar");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_card_subtitle = _resolveComponent("v-card-subtitle");
            const _component_v_card_item = _resolveComponent("v-card-item");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_chip = _resolveComponent("v-chip");
            return (dataset.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_card, {
                        variant: "flat",
                        class: "mb-4"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_item, null, {
                                prepend: _withCtx(() => [
                                    _createVNode(_component_v_avatar, {
                                        color: "primary",
                                        variant: "tonal",
                                        size: "48",
                                        rounded: "lg"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { size: "24" }, {
                                                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                                        _createTextVNode("mdi-database", -1)
                                                    ]))]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "text-h6 font-weight-medium" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(dataset.value.name), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_card_subtitle, { class: "text-body-2" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                                size: "x-small",
                                                class: "mr-1"
                                            }, {
                                                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                        _createTextVNode("mdi-account", -1)
                                                    ]))]),
                                                _: 1
                                            }),
                                            _createTextVNode(" " + _toDisplayString(dataset.value.creator_username), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_v_chip, {
                            variant: "tonal",
                            color: "primary",
                            size: "small",
                            "prepend-icon": "mdi-file-multiple"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(numItems.value) + " items ", 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_chip, {
                            variant: "tonal",
                            color: "secondary",
                            size: "small",
                            "prepend-icon": "mdi-harddisk"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(filesize(total_size_in_bytes.value)), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_chip, {
                            variant: "tonal",
                            size: "small",
                            "prepend-icon": "mdi-calendar-plus"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(" Created " + _toDisplayString(_unref(formatDate)(dataset.value.created_at)), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_chip, {
                            variant: "tonal",
                            size: "small",
                            "prepend-icon": "mdi-calendar-check"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(" Frozen " + _toDisplayString(_unref(formatDate)(dataset.value.frozen_at)), 1)
                            ]),
                            _: 1
                        }),
                        (dataset.value.uploaded_by)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 0,
                                variant: "tonal",
                                color: "info",
                                size: "small",
                                "prepend-icon": "mdi-account-arrow-up",
                                title: 'Authenticated identity that registered this dataset'
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(" Uploaded by " + _toDisplayString(dataset.value.uploaded_by), 1),
                                    (dataset.value.uploaded_at)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(" on " + _toDisplayString(_unref(formatDate)(dataset.value.uploaded_at)), 1)
                                        ], 64))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
